import(/* webpackMode: "eager", webpackExports: ["BaseAppBar"] */ "/usr/src/app/frontend/src/components/layout/app-bar/base-app-bar.tsx");
